const borderRadius = {
  fragmentRadius: 10,
  componentRadius: 20,
}

export default borderRadius
